import { SortOrderTypePublicCorps } from "enums";
import React, { useEffect } from "react";

type PROPS = {
  value: string | undefined;
  onChange: (value: string) => void;
};

const CorpSearchSortSelect: React.FC<PROPS> = (props) => {
  const [sortOrder, setSortOrder] = React.useState<string>("");

  useEffect(() => {
    setSortOrder(props.value ?? "");
  }, [props.value]);

  return (
    <select
      className="border border-gray-600 rounded py-2 cursor-pointer"
      value={sortOrder}
      onChange={(e) => {
        const value = e.target.value;
        setSortOrder(value);

        props.onChange(value);
      }}
    >
      <option value={SortOrderTypePublicCorps.UPDARE_DATE_NEW}>新着順</option>
      <option value={SortOrderTypePublicCorps.CORP_NAME_ASC}>会社名昇順</option>
      <option value={SortOrderTypePublicCorps.CORP_NAME_DESC}>
        会社名降順
      </option>
      <option value={SortOrderTypePublicCorps.CAPITAL_HIGH}>
        資本金が多い順
      </option>
    </select>
  );
};

export default CorpSearchSortSelect;
